import { PageTracking } from "library/hoc/PageTracking";
import { PageData } from "../../types";
import { HomePageComponent } from "./HomePageComponent";

const pageData: PageData = {
  page: {
    siteSection: "sign-in",
    siteSubSection: "",
    pageTitle: "sign-in",
    pageType: "input-page",
  },
};

export const HomePage = ({ Component = HomePageComponent, ...props }) => (
  <PageTracking pageData={pageData}>
    <Component {...props} />
  </PageTracking>
);
